import React from 'react';
import DataTable from '../../components/dataTable';
import {formatDateTimeColumn} from '../../helpers/excel-helper';


const DeviceTable = (props) => {
  const {
    deviceForm,
    removeRegister,
    attributes,
    permissions,
    list,
    loading,
    timezone,
    intl
  } = props;

  return (
    <DataTable
      add={deviceForm}
      edit={deviceForm}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      permissions={permissions}
      keyField={'id'}
      confirmText={`Você está removendo o device <strong><field>name</field></strong>! </br>Realmente deseja fazer isso? `}
      headers={[
        {title: 'sharedName', field: 'name', dataSort: true},
        {title: 'deviceIdentifier', field: 'uniqueId', dataSort: true},
        {title: 'deviceModel', field: 'model', dataSort: true},
        {title: 'groupDialog', field: 'groupName', dataSort: true },
        {title: 'sharedDisabled', field: 'disabled', dataSort: true},
      ]}
      excelConfig={{
        fileName : 'deviceTitle',
        columns : [
          {label: 'sharedName', field: 'name'},
          {label: 'deviceIdentifier', field: 'uniqueId'},
          {label: 'deviceModel', field: 'model'},
          {label: 'groupDialog', field: 'groupName'},
          {label: 'deviceCategory', field: 'category'},
          {label: 'deviceContact', field: 'contact'},
          {label: 'sharedDisabled', field: (col) => col.disabled ? intl.formatMessage({ id: 'sharedYes' }) : intl.formatMessage({ id: 'sharedNo' })},
          {label: 'sharedPhone', field: 'phone'},
          {label: 'deviceLastUpdate', field: (col) => formatDateTimeColumn(col, timezone)},
        ]
      }}
    />
  );
};

export default DeviceTable;
